import { type ComponentProps, type ComponentPropsWithoutRef, type FC } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';
import * as Dialog from '@radix-ui/react-dialog';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';

import {
  backButtonClass,
  dialogContentMobileClass,
  navigationMenuContentDesktopClass,
  navigationMenuTriggerClass,
  navigationMenuWrapperClass,
  triggerClass,
} from './MegaMenu.css';

export { Dialog };
export { NavigationMenu };

export const StyledNavigationMenuContentDesktop: FC<
  ComponentProps<typeof NavigationMenu.Content>
> = ({ className, ...rest }) => (
  <NavigationMenu.Content
    className={getClassNames(navigationMenuContentDesktopClass, className)}
    {...rest}
  />
);

export const StyledDialogContentMobile: FC<ComponentProps<typeof Dialog.Content>> = ({
  className,
  ...rest
}) => (
  <Dialog.Content className={getClassNames(dialogContentMobileClass, className)} {...rest} />
);

export const StyledTrigger: FC<ComponentProps<typeof Dialog.Trigger>> = ({
  className,
  ...rest
}) => <Dialog.Trigger className={getClassNames(triggerClass, className)} {...rest} />;

export const StyledNavigationMenuTriger: FC<ComponentProps<typeof NavigationMenu.Trigger>> = ({
  className,
  ...rest
}) => (
  <NavigationMenu.Trigger
    className={getClassNames(triggerClass, navigationMenuTriggerClass, className)}
    {...rest}
  />
);

export const BackButton: FC<ComponentPropsWithoutRef<'button'>> = ({ className, ...rest }) => (
  <button className={getClassNames(backButtonClass, className)} {...rest} />
);

export const NavigationMenuWrapper: FC<ComponentPropsWithoutRef<'div'>> = ({
  className,
  ...rest
}) => <div className={getClassNames(navigationMenuWrapperClass, className)} {...rest} />;
